module.exports = __webpack_public_path__ + "static/media/pt.56772531.svg";